import script from "./PaginationItems.vue?vue&type=script&setup=true&lang=js"
export * from "./PaginationItems.vue?vue&type=script&setup=true&lang=js"

import "./PaginationItems.vue?vue&type=style&index=0&id=01d108c0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01d108c0"]])

export default __exports__